module.exports = __webpack_public_path__ + "src/assets/img/share/tips/conscientiousness/70faf377e532af6625f7a5b85a513091.png";